export default __webpack_public_path__ + "static/media/Plissee ausmessen seitlich.0a2d6f92.jpg";